module.exports = __webpack_public_path__ + "img/banner_ongoing_KR.bbdf0c93.png";